import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import theme from 'assets/theme'

export interface QuoteAnswerAttributeProps {
  heading: string
  value: string
}

const QuoteAnswerAttribute = ({
  heading,
  value,
}: QuoteAnswerAttributeProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Grid container>
      <Stack direction={isMobile ? 'column' : 'row'} width="100%">
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="p3" component="p" color="primary.main">{heading}</Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="p3" color="primary.main">{value}</Typography>
        </Grid>
      </Stack>
    </Grid>
  )
}

export default QuoteAnswerAttribute

